import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceSubscribe from "@/pages/IntelligenceSubscribe";

export const Route = createFileRoute("/_app/intelligence/subscribe")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceSubscribe /></PageGate>
  ),
});
